module.exports = __webpack_public_path__ + "html/company_c450981907dc70f2db6d5e828864bd87.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/company.html
// module id = BjDr
// module chunks = 125